import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SafeHtmlPipe } from 'src/app/core/pipes/safe-html.pipe';
import { ErrorService } from 'src/app/core/services/error.service';

export interface IInputToggleGroupOption {
  label: string
  value: string
}

@Component({
  selector: 'app-input-toggle-group',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonToggleGroup,
    MatSlideToggleModule,
    MatFormFieldModule,
    SafeHtmlPipe,
  ],
  templateUrl: './input-toggle-group.component.html',
  styleUrl: './input-toggle-group.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputToggleGroupComponent {
  @Input() name: string = '';
  @Input() label?: string;
  @Input() icon?: string;
  @Input() hint?: string;
  @Input() form!: FormGroup;
  @Input() labelError?: string;
  @Input() class: string = 'pb-3';
  @Input() options: Array<IInputToggleGroupOption> = [];
  @Input({ transform: booleanAttribute }) vertical: boolean = true;

  constructor(
    private errorService: ErrorService
  ) {}

  toggleOption(optionValue: string) {
    const currentValues = this.form.get(this.name)?.value as string[] ?? [];
    if (currentValues.includes(optionValue)) {
      let newValues: string[] | null = currentValues.filter((val) => val !== optionValue);
      newValues = newValues.length > 0 ? newValues : null;
      this.form.get(this.name)?.setValue(newValues);
    } else {
      this.form.get(this.name)?.setValue([...currentValues, optionValue]);
    }
  }

  hasError() {
    return this.errorService.hasError(this.form, this.name);
  }

  error() {
    return this.errorService.error(this.form, this.name, this.labelError ?? this.label);
  }
}
